import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useNavbarStore = defineStore('navbar', () => {
  // State
  const navbar = ref([])
  const gameCodes = ref([])
  const loading = ref(false)
  const error = ref(null)

  // Getters
  const getNavbar = computed(() => navbar.value)
  const getGameCodes = computed(() => gameCodes.value)
  const getLoading = computed(() => loading.value)
  const getError = computed(() => error.value)
  const hasNavbar = computed(() => navbar.value.length > 0)

  // Actions
  function setNavbar(data) {
    navbar.value = data
  }

  function setGameCodes(data) {
    gameCodes.value = data
  }

  function setLoading(data) {
    loading.value = data
  }

  function setError(data) {
    error.value = data
  }

  function clearError() {
    error.value = null
  }

  function reset() {
    navbar.value = []
    gameCodes.value = []
    loading.value = false
    error.value = null
  }

  return {
    // State
    navbar,
    gameCodes,
    loading,
    error,

    // Getters
    getNavbar,
    getGameCodes,
    getLoading,
    getError,
    hasNavbar,

    // Actions
    setNavbar,
    setGameCodes,
    setLoading,
    setError,
    clearError,
    reset,
  }
})
